import React from 'react';
import { QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Me cambió la forma de ver la crianza. Ahora entiendo qué necesita mi hijo y cómo acompañarlo sin gritos.',
  name: 'Carolina Méndez'
}, {
  quote: 'Las rutinas nos salvaron. Las mañanas son mucho más tranquilas.',
  name: 'Julián Torres'
}, {
  quote: 'Me dio herramientas reales para calmarme yo primero.',
  name: 'Sofía Roldán'
}, {
  quote: 'No es teoría linda. Es práctico y funciona.',
  name: 'Valentina García'
}, {
  quote: 'Te acompaña sin hacerte sentir mal padre.',
  name: 'Martín Benítez'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#FDF8F3] py-16 px-4" data-id="element-248">
      <div className="max-w-5xl mx-auto" data-id="element-249">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#5C4033] mb-12 text-center" data-id="element-250">
          💬 Lo que dicen otras familias
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-251">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#F5EDE4] rounded-2xl p-6 border border-[#E0D5C8]" data-id="element-252">
              <QuoteIcon className="w-8 h-8 text-[#D4956A] mb-4" data-id="element-253" />
              <p className="text-[#8B7355] mb-6 italic" data-id="element-254">
                "{testimonial.quote}"
              </p>
              <p className="font-semibold text-[#5C4033]" data-id="element-255">
                — {testimonial.name}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}